
import { Vue, Options } from "vue-class-component";
import { Prop, Emit, Ref } from "vue-property-decorator";
import { LabelAndValue } from "../../types";
import ActionButton from "../atoms/ActionButton.vue";
import UIkit from "uikit";
@Options({
  components: { ActionButton }
})
export default class ActionMenu extends Vue {
  @Prop({ type: String }) title = "Button";
  @Prop({ type: String }) color: "primary" | "default" | "secondary" | "danger" | "warn" = "default";
  @Prop({ type: String }) shape: "round" | "rect" = "rect";
  @Prop({ type: String }) width?: number;
  @Prop({ type: Array, required: true }) items: LabelAndValue[] = [];
  @Ref("menu") menu?: HTMLElement;
  @Emit("item-click")
  onItemClick(item: LabelAndValue) {
    if (this.menu) {
      UIkit.dropdown(this.menu).hide();
    }
    return item;
  }
}
